import { commonTranslations } from '../../../common-assets/js/components/common_translations_en';

const carTranslations = {
    'review_not_for_dealer_text': 'Private seller car reviews are unfortunately unavailable for dealers.',
    'add_to_favourite': 'Add to Favorites',
    'add_to_favourite_double_line': 'Add to<br />Favorites',
    'ad_post': {
        'error_message': {
            'acceleration': 'Please give acceleration in numeric form.',
            'top_speed': 'Please give top speed in numeric form.',
            'urban_consumption': 'Please give urban consumption in numeric form.',
            'road_consumption': 'Please give road consumption in numeric form.',
            'combined_consumption': 'Please give combined consumption in numeric form.',
            'curb_weight': 'Please give curb weight in numeric form.',
            'gross_weight': 'Please give gross weight in numeric form.',
            'electric_urban_consumption': 'Please give urban consumption in numeric form.',
            'electric_road_consumption': 'Please give road consumption in numeric form.',
            'electric_combined_consumption': 'Please give combined consumption in numeric form.',
            'maximum_charging_power': 'Please give maximum charging power in numeric form.',
            'battery_capacity': 'Please check battery capacity.',
            'battery_capacity_format': 'Please enter battery capacity as numbers with max. two decimals.',
            'battery_guarantee_kilometer': 'Please enter battery guarantee kilometers in numeric form. If no guarantee exists, leave field empty.',
            'battery_guarantee_month': 'Please enter battery guarantee months in numeric form. If no guarantee exists, leave field empty.',
            'body_type': 'Please select car type.',
            'charging_power': 'Please give charging power in numeric form.',
            'charging_power_format': 'Please enter charging power as numbers with max. one decimal.',
            'charging_type_maximum_limit': 'Please select a maximum of 3 charging types.',
            'electric_emission': 'Please give CO2 emission as numbers.',
            'electric_range': 'Please give range in numeric form.',
            'emission': 'Please give CO2 emission as numbers.',
            'model_type_length': 'Engine model can be max. 120 characters.',
            'select_model': 'Please select exchange car makes and models.',
            'to_price': 'Minimum price cannot be greater than maximum price.',
            'torque': 'Please give torque in numeric form.',
            'tow_weight_with_brakes': 'Please give tow weight (with brakes) in numeric form.',
            'tow_weight_without_brakes': 'Please give tow weight (without brakes) in numeric form.',
            'invalid_price': 'Price must be at least €51.',
            'validate_vin_empty': 'Please give registration number or vehicle identification number (VIN)',
            'vin': 'Please check VIN',
            'vin_post_year_1982': 'VIN must be exactly 17 characters',
            'vin_pre_year_1981': 'VIN must be 5-17 characters for vehicles manufactured in 1981 or earlier',
            'punchline_mandatory': 'Campaign information is mandatory',
            'punchline_limit': 'Punchline text allows upto 150 characters',
            'campaign_body_limit': 'Body text allows upto 5000 characters',
            'prefill_rate_limit_message': 'You have used the maximum number of prefill requests which is 3 per 8 weeks. Please enter vehicle information manually.',
        },
        'lock_field': 'Lock this field',
        'update_gh_data_text': 'You are editing pre-filled vehicle information.',
    },
    'advanced_search': {
        'undriven_only': 'Undriven only',
        'hide_van_subtype': 'Hide van body types',
        'show_van_subtype': 'View van body types…',
        'region_placeholder': 'Region or city',
        'dealership_selection_limit': 'You can select a maximum of 5 dealerships.',
        'dealer_ship_list_placeholder': 'Select one or more',
        'error_message': {
            'invalid_chargin_power': 'Please give charging power as numbers between 1-1000.',
            'invalid_chargin_power_range': 'The lower limit cannot be greater than the upper limit',
            'invalid_co2_range': 'The lower limit cannot be greater than the upper limit',
            'invalid_inspection_year': 'Please select the "year" from the drop down box to search vehicles inspected after specific date.',
            'invalid_registration_year': 'Please select the "year" from the drop down box to search first registration date of vehicle.',
            'invalid_tow_weight': 'Enter a proper Tow weight value. The value must be in between 1 and 3500',
            'invalid_tow_weight_range': 'The lower limit cannot be greater than the upper limit',
        },
    },
    'own_ad': {
        'send_link_to_friend': {
            'select_min_ad': 'Please select at least 1 Car to sent its vehicle Information link',
        },
    },
    'simple_search': {
        'search_id_message': 'Please enter ad ID, registration number or VIN',
        'id_search': {
            'required_field_value': 'Please fill in registration number, ad ID or VIN',
            'valid_id_ad_not_found': 'No ad currently found for the ad ID.',
            'valid_reg_no_ad_not_found': 'No ad found for the registration number.',
            'valid_vin_no_ad_not_found': 'No ad found for VIN',
            'wrong_data': 'Please fill in registration number as abc-123, ad ID as 1234567 or VIN 2GNFLFEK1F6224271',
        },
    },
    'search_agent': {
        'search_agent_disabled': 'Your search agent has been deactivated, and you will no longer receive emails. You can reactivate the search agent whenever you wish.',
        'search_agent_enabled': 'Thank you for the confirmation! Your Nettiauto search agent is active for the next 8 weeks.',
    },
    'sell_ad': {
        'register_number_invalid': 'Please enter registration number or vehicle identification number (VIN).',
    },
    'dealer_stat': {
        'kpl': '',
        'krt': '',
        'press_escape_to_close': 'Press Escape to close',
        'previous_week': 'previous 7 days',
        'previous_month': 'previous 30 days',
        'previous_year': 'previous 12 months',
        'customer_contact': {
            'phone': 'Phone',
            'email': 'Email',
            'chat': 'Chat',
            'whatsapp': 'WhatsApp',
        },
        'number_of_contacts': {
            'all': 'All',
            'phone': 'Phone',
            'email': 'Email',
            'whatsapp': 'WhatsApp',
        },
        'last_week': 'during the last 7 days',
        'last_month': 'during the last 30 days',
        'last_year': 'during the last 12 months',
        'key_figures_graph': {
            'page_views': 'Pageviews',
            'contacts': 'Contacts',
            'created_ads': 'Active listings',
            'removed_ads': 'Removed ads',
        },
        'campaigns_visibility': {
            'campaigns': 'Campaigns',
            'visibility': 'Added visibility',
        },
    },
    'chatbot': {
        'error': {
            'empty_message': 'Please type a message to continue.',
            'timeout': 'The request timed out. Please try again.',
            'network': 'Connection issue. Please check your internet connection.',
            'auth': 'Your session has expired. Please refresh the page.',
            'server': 'Server error. Please try again later.',
            'general': 'An error occurred. Please try again.',
        },
    },
};

globalThis.Translations = commonUtils.mergeObjects(commonTranslations, carTranslations);
